import img1 from "./WhatsApp Image 2025-12-14 at 9.44.44 PM (1).jpeg";
import img2 from "./WhatsApp Image 2025-12-14 at 9.44.44 PM (2).jpeg";
import img3 from "./WhatsApp Image 2025-12-14 at 9.44.44 PM.jpeg";
import img4 from "./WhatsApp Image 2025-12-14 at 9.44.45 PM (1).jpeg";
import img5 from "./WhatsApp Image 2025-12-14 at 9.44.45 PM.jpeg";
import img6 from "./WhatsApp Image 2025-12-14 at 9.44.46 PM (1).jpeg";
import img7 from "./WhatsApp Image 2025-12-14 at 9.44.46 PM (2).jpeg";
import img8 from "./WhatsApp Image 2025-12-14 at 9.44.46 PM (3).jpeg";
import img9 from "./WhatsApp Image 2025-12-14 at 9.44.46 PM (4).jpeg";
import img10 from "./WhatsApp Image 2025-12-14 at 9.44.46 PM.jpeg";
import img11 from "./WhatsApp Image 2025-12-14 at 9.44.47 PM (1).jpeg";
import img12 from "./WhatsApp Image 2025-12-14 at 9.44.47 PM (2).jpeg";
import img13 from "./WhatsApp Image 2025-12-14 at 9.44.47 PM (3).jpeg";
import img14 from "./WhatsApp Image 2025-12-14 at 9.44.47 PM (4).jpeg";
import img15 from "./WhatsApp Image 2025-12-14 at 9.44.47 PM (5).jpeg";
import img16 from "./WhatsApp Image 2025-12-14 at 9.44.47 PM (6).jpeg";
import img17 from "./WhatsApp Image 2025-12-14 at 9.44.47 PM (7).jpeg";
import img18 from "./WhatsApp Image 2025-12-14 at 9.44.47 PM (8).jpeg";
import img19 from "./WhatsApp Image 2025-12-14 at 9.44.47 PM.jpeg";
import img20 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM (1).jpeg";
import img21 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM (2).jpeg";
import img22 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM (3).jpeg";
import img23 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM (4).jpeg";
import img24 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM (5).jpeg";
import img25 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM (6).jpeg";
import img26 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM (7).jpeg";
import img27 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM (8).jpeg";
import img28 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM (9).jpeg";
import img29 from "./WhatsApp Image 2025-12-14 at 9.44.48 PM.jpeg";
import img30 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (1).jpeg";
import img31 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (2).jpeg";
import img32 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (3).jpeg";
import img33 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (4).jpeg";
import img34 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (5).jpeg";
import img35 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (6).jpeg";
import img36 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (7).jpeg";
import img37 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (8).jpeg";
import img38 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (9).jpeg";
import img39 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM (10).jpeg";
import img40 from "./WhatsApp Image 2025-12-14 at 9.44.49 PM.jpeg";
import img41 from "./WhatsApp Image 2025-12-14 at 9.44.50 PM (1).jpeg";
import img42 from "./WhatsApp Image 2025-12-14 at 9.44.50 PM (2).jpeg";
import img43 from "./WhatsApp Image 2025-12-14 at 9.44.50 PM (3).jpeg";
import img44 from "./WhatsApp Image 2025-12-14 at 9.44.50 PM (4).jpeg";
import img45 from "./WhatsApp Image 2025-12-14 at 9.44.50 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
];
